

import { Component, Vue, Prop } from 'vue-property-decorator';
import { TSrc } from "@/components/IBPayment/interface";

@Component
export default class IBPaymentCardIcon extends Vue {

	@Prop(String)
	readonly src!: TSrc

	@Prop(String)
	readonly font!: string

}

